import { BASE_KNOWN_ERC20 } from './consts'
import { KnownTokensValue } from './known-tokens'

export const ARBITRUM_SEPOLIA_KNOWN_TOKENS: KnownTokensValue = {
  EUROS: {
    id: '0x0c39589605DC00922e3762588961DE39eAfA4395',
    contractAddress: '0x0c39589605DC00922e3762588961DE39eAfA4395',
    name: 'EUROS',
    symbol: 'EUROS',
    decimals: 18,
    ...BASE_KNOWN_ERC20,
  },
  USDC: {
    id: '0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d',
    contractAddress: '0x75faf114eafb1BDbe2F0316DF893fd58CE46AA4d',
    name: 'USD Coin',
    symbol: 'USDC',
    decimals: 6,
    ...BASE_KNOWN_ERC20,
  },
}
